"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));

var Portal_1 = __importDefault(require("@material-ui/core/Portal"));

var react_1 = __importDefault(require("react"));

require("./BB8PageSpinner.scss");

var BB8SpinnerSize;

(function (BB8SpinnerSize) {
  BB8SpinnerSize[BB8SpinnerSize["Big"] = 200] = "Big";
})(BB8SpinnerSize = exports.BB8SpinnerSize || (exports.BB8SpinnerSize = {}));

var BB8Spinner =
/** @class */
function (_super) {
  __extends(BB8Spinner, _super);

  function BB8Spinner(props) {
    return _super.call(this, props) || this;
  }

  BB8Spinner.prototype.componentWillMount = function () {
    this.container = document.createElement("div");
    this.container.id = "spinner-root";
    document.body.appendChild(this.container);
  };

  BB8Spinner.prototype.render = function () {
    this.setupContainer();

    var _a = this.props,
        show = _a.show,
        props = __rest(_a, ["show"]);

    return show ? react_1.default.createElement(Portal_1.default, {
      container: this.container
    }, react_1.default.createElement(CircularProgress_1.default, __assign({}, props))) : react_1.default.createElement(react_1.default.Fragment, null);
  };

  BB8Spinner.prototype.componentWillUnmount = function () {
    if (this.container) {
      document.body.removeChild(this.container);
    }
  };

  BB8Spinner.prototype.setupContainer = function () {
    if (this.container && this.container instanceof HTMLElement) {
      this.props.show ? this.container.classList.add("shown") : this.container.classList.remove("shown");
    }
  };

  return BB8Spinner;
}(react_1.default.Component);

exports.BB8Spinner = BB8Spinner;
exports.default = BB8Spinner;